export default __webpack_public_path__ + "static/media/latin2.13687f03.webp";